import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormModelControl } from '@bcl/common-ui';
import { SelectOption } from '@bcl/design-system';
import { MonitorWithOptions } from 'src/app/pages/area/area.model';
import { DictionaryItem } from 'src/app/services/dictionary.service';

type ObservationForm = {
  observationId: string | null;
};

@Component({
  selector: 'app-observation-dialog',
  templateUrl: './observation-dialog.component.html',
  styleUrls: ['./observation-dialog.component.scss'],
})
export class ObservationDialogComponent {
  public observationForm: FormGroup<FormModelControl<ObservationForm>>;
  public monitor: MonitorWithOptions;
  public observationOptions: SelectOption[] = [];
  constructor(
    public dialogRef: MatDialogRef<ObservationDialogComponent>,
    fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any | null
  ) {
    this.observationForm = fb.group({
      observationId: [null as string | null, Validators.required],
    });
    if (data) {
      this.monitor = data.monitor;

      this.observationOptions = data.observations.filter(
        (observation) => observation.value !== '200'
      );
      this.observationForm.patchValue({
        observationId: this.monitor.observation.id.toString(),
      });
    }
  }

  public save(): void {
    const formValue = this.observationForm.value;
    this.dialogRef.close(formValue.observationId);
  }
}
